document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.creator-videos:not(.creator-videos--pool)');
  if (!root) return;

  var list = root.querySelector('[data-creator-list]');
  if (list) {
    document.querySelectorAll('[data-creator-pool] > li').forEach(function (card) {
      list.appendChild(card);
    });
  }
  document.querySelectorAll('.creator-videos--pool').forEach(function (pool) {
    var wrapper = pool.closest('[id^="shopify-section-"]');
    if (wrapper) wrapper.remove();
    else pool.remove();
  });

  var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 12;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-creator-list] > li'));
  var filters = Array.prototype.slice.call(root.querySelectorAll('[data-creator-filters] > li'));
  var moreButton = root.querySelector('[data-creator-more]');
  var filterEmpty = root.querySelector('[data-creator-empty="filter"]');
  var popup = root.querySelector('[data-creator-popup]');
  var player = root.querySelector('[data-creator-player]');
  var shown = pageSize;
  var activeFilter = 'all';

  function matches(card) {
    if (activeFilter === 'all') return true;
    var products = (card.getAttribute('data-products') || '').split('||').map(function (item) {
      return item.trim();
    }).filter(Boolean);
    return products.indexOf(activeFilter) !== -1;
  }

  function render() {
    var visible = cards.filter(matches);
    cards.forEach(function (card) {
      card.hidden = visible.indexOf(card) === -1 || visible.indexOf(card) >= shown;
    });
    if (filterEmpty) filterEmpty.hidden = visible.length !== 0;
    if (moreButton) moreButton.hidden = visible.length <= shown;
  }

  filters.forEach(function (filter) {
    filter.addEventListener('click', function () {
      activeFilter = filter.getAttribute('data-filter') || 'all';
      shown = pageSize;
      filters.forEach(function (item) {
        item.classList.toggle('is--actived', item.getAttribute('data-filter') === activeFilter);
      });
      var desktop = filter.closest('.desktop-view');
      if (desktop) {
        desktop.style.setProperty('--after-top', filter.offsetTop + 'px');
        desktop.style.setProperty('--after-height', filter.offsetHeight + 'px');
      }
      render();
    });
  });

  if (moreButton) {
    moreButton.addEventListener('click', function () {
      shown += pageSize;
      render();
    });
  }

  function closePlayer() {
    if (!popup) return;
    popup.classList.remove('active');
    if (player) player.innerHTML = '';
  }

  root.addEventListener('click', function (event) {
    var play = event.target.closest('[data-video-id], [data-bilibili-id], [data-douyin-id], [data-external-url], [data-tiktok-id], [data-facebook-url]');
    if (!play || !player || !popup) return;
    var bilibiliId = play.getAttribute('data-bilibili-id');
    var douyinId = play.getAttribute('data-douyin-id');
    var externalUrl = play.getAttribute('data-external-url');
    var tiktokId = play.getAttribute('data-tiktok-id');
    var facebookUrl = play.getAttribute('data-facebook-url');
    var videoId = play.getAttribute('data-video-id');
    if (externalUrl) {
      window.open(externalUrl, '_blank', 'noopener,noreferrer');
      return;
    } else if (bilibiliId) {
      player.innerHTML = '<iframe src="https://player.bilibili.com/player.html?bvid=' + encodeURIComponent(bilibiliId) + '&autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (douyinId) {
      player.innerHTML = '<iframe src="https://open.douyin.com/player/video?vid=' + encodeURIComponent(douyinId) + '&autoplay=1" referrerpolicy="unsafe-url" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (tiktokId) {
      player.innerHTML = '<iframe src="https://www.tiktok.com/player/v1/' + encodeURIComponent(tiktokId) + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (facebookUrl) {
      player.innerHTML = '<iframe src="https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(facebookUrl) + '&show_text=false&autoplay=true" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (videoId) {
      player.innerHTML = '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else {
      return;
    }
    popup.classList.add('active');
  });

  root.querySelectorAll('[data-creator-close]').forEach(function (closer) {
    closer.addEventListener('click', closePlayer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePlayer();
  });

  if (window.Swiper) {
    var slider = root.querySelector('.guide-tutorials_tab-item-slider');
    if (slider) {
      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true
      });
    }
  }

  render();
});
